import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/add-event2.svg'


const _hoisted_1 = {
  class: "card border-0 rounded-3 bg-primary-70 position-relative z-1 welcome-for-hotel",
  style: {"padding":"20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"d-flex d-md-block justify-content-between align-items-center\"><div><span class=\"d-block\">New Bookings</span><h3 class=\"fs-28 fw-900 mt-6 mb-11 lh-1\">1540</h3><div><span class=\"d-inline-block bg-card-text-c border-danger-50 border px-2 rounded-pill text-danger-50 fs-12 fw-medium\"> -4.15% </span></div></div><div class=\"d-flex justify-content-end\" style=\"margin-top:-15px;\"><div class=\"bg-white rounded-circle d-flex align-items-center justify-content-end\" style=\"width:79px;height:79px;\"><img src=\"" + _imports_0 + "\" alt=\"add-event2\"></div></div></div>", 1)
  ]))]))
}